import React from "react";
import {FormSectionElements} from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import {LiveValidationErrMsg} from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import {displayField, getRootComponent} from "../../utilities/ElementUtils";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
 
}

export class HealthCardComponent extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

   let field = this.props.field;
  //  FormValidationUtils.runJavascript(field);

  //  field.Script=`(field)=>{
  //     try {
  //       let fieldVal = field.Value;

  //       if (fieldVal) {
  //           if (fieldVal) {
  //               if (fieldVal.substring(4, 5) != "-") {
  //                   fieldVal = fieldVal.substring(0, 4) + "-" + fieldVal.substring(4);
  //               }
  //               if (fieldVal.substring(8, 9) != "-") {
  //                   fieldVal = fieldVal.substring(0, 8) + "-" + fieldVal.substring(8);
  //               }
  //               if (fieldVal.substring(12, 13) != "-") {
  //                   fieldVal = fieldVal.substring(0, 12) + "-" + fieldVal.substring(12);
  //               }
  //               field.Value = fieldVal.toUpperCase();
  //           }

  //       }
  //     } catch (ex) {
  //       console.log(ex)
  //   }
  //   }`
}

    onChange = (e) => {
        let field = this.props.field;
        let val = e.target.value?.trim();
        const delEndingDash = field.Value?.length === (val?.length + 1) && field.Value.endsWith('-') && !val.endsWith('-');
        field.Value = val;


        if (!delEndingDash) {
            FormValidationUtils.processHealthCardValidation(field);
        }
        this.props.callbackElement(getRootComponent(field));
    }

    onBlur = (e) => {
        let field = this.props.field;
        FormValidationUtils.processHealthCardValidation(field);
        this.props.callbackElement(getRootComponent(field));
    }


  render() {
    let field = this.props.field;
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    const display = displayField(field);

    if (!display) return null;

    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}>

          <div key={'fdLbl_div_' + field.Id} >
            {labelControlArray}
          </div>
          <div>
            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />

          </div>
            <div key={'fdIpt_div_' + field.Id}>
                <div>
                    <input
                        aria-invalid={!field?.Valid}
                        aria-describedby={`${field.LoadBindName}-${field.Id} ${field.LoadBindName}-hint ${field.LoadBindName}-${field.Id}-error`}
                        className={field.Valid || !field.Touched ? 'ontario-input ontario-input--20-char-width' : 'ontario-input ontario-input--20-char-width ontario-input__error'}
                        id={field.LoadBindName}
                        key={'fdIpt_' + field.Id}
                        required={requiredField} value={field.Value}
                        readOnly={field.ReadOnly}
                        onBlur={this.onBlur} maxLength={15}
                        onChange={this.onChange}/>
                </div>
            </div>
        </div>);
    } else {
      controlArray.push(
        <div className={classNames('pdf-two-column', { 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >
          <div>{title}</div>
          <div> {field.Value}</div>
        </div>
      );
    }

    return controlArray;

  }

}